import bsn from 'libraries/bootstrap-native.js';
import events from 'events.js';
import ko from 'knockout';

ko.bindingHandlers.tooltip = {
    init(elem, valueAccessor) {
        const isMobileOrTablet = navigator.userAgent.match(
            /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i,
        );
        let trigger = 'hover';
        if (isMobileOrTablet) {
            trigger = 'click';
        }
        let placement = 'top';
        if (elem.dataset.placement) {
            placement = elem.dataset.placement;
        }
        let title = ko.unwrap(valueAccessor());
        if (typeof title !== 'string') {
            title = elem.getAttribute('title');
        }
        elem.removeAttribute('title');
        const popover = new bsn.Popover(elem, {
            trigger,
            placement: placement,
            template: `<div class="popover" role="tooltip">
                <div class="arrow"></div>
                <h3 class="popover-title">${title}</h3>
            </div>`,
        });
        let tooltipOpen = false;
        if (isMobileOrTablet) {
            events.listen(document.body, 'click', function() {
                if (tooltipOpen) {
                    popover.hide();
                    tooltipOpen = false;
                }
            });
            events.listen(document.body, 'touchstart', function() {
                if (tooltipOpen) {
                    popover.hide();
                    tooltipOpen = false;
                }
            });
            const elems = Array.from(
                document.getElementsByClassName('gap-scheme-tooltip'),
            );
            for (const elem of elems) {
                events.listen(elem, 'click', function() {
                    if (!tooltipOpen) {
                        setTimeout(function() {
                            tooltipOpen = true;
                        }, 10);
                    }
                });
            }
        }
    },
};
